/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerBlender('horizontalverticalalphablurkernel5', function (imgData, background, cb) {
    var tmpCanvas = document.createElement('canvas'), ctx,
        image = document.createElement('canvas');
    var tmpPx, px = imgData.data, length = px.length, i,j;
    var leftleftkernel, leftkernel, middlekernel, rightkernel, rightrightkernel;

    image.width = imgData.width;
    image.height = imgData.height;
    tmpCanvas.width = imgData.width;
    tmpCanvas.height = imgData.height;

    function filterAlpha(defaultvalue) {
        var alpha = defaultvalue;
        if (leftleftkernel <= leftkernel && leftkernel <= middlekernel
                && middlekernel >= rightkernel && rightkernel >= rightrightkernel){
            // middle kernel top -> decrease alpha
            alpha = Math.min(leftleftkernel, rightrightkernel);
        } else if (leftleftkernel > leftkernel && leftkernel > middlekernel
                && middlekernel > rightkernel && rightkernel > rightrightkernel) {
            // leftleft kernel top -> median alpha
            alpha = leftleftkernel + rightrightkernel / 2;
        } else if (leftleftkernel < leftkernel && leftkernel < middlekernel
                && middlekernel < rightkernel && rightkernel < rightrightkernel) {
            // rightright kernel top -> median alpha
            alpha = leftleftkernel + rightrightkernel / 2;
        } else if (leftleftkernel > leftkernel && leftkernel < middlekernel
                && middlekernel < rightkernel && rightkernel < rightrightkernel) {
            // middle kernel bottom -> increase alpha
            alpha = Math.max(leftleftkernel, rightrightkernel);
        }
        return alpha;
    }

    for (j = 0; j < 1; j++){
        tmpPx = px.slice();

        for (i = 3; i < length; i=i+4){
            leftleftkernel = tmpPx[i - 4 * 2] || tmpPx[i];
            leftkernel = tmpPx[i - 4] || tmpPx[i];
            middlekernel = tmpPx[i];
            rightkernel = tmpPx[i + 4] || tmpPx[i];
            rightrightkernel = tmpPx[i + 4 * 2] || tmpPx[i];
            px[i] = filterAlpha(leftleftkernel, leftkernel, middlekernel, rightkernel, rightrightkernel, px[i]);
        }

       for (i = 3; i < length; i=i+4){
           leftleftkernel = tmpPx[i - 4 * 2 * imgData.width] || tmpPx[i];
           leftkernel = tmpPx[i - 4 * imgData.width] || tmpPx[i];
           middlekernel = tmpPx[i];
           rightkernel = tmpPx[i + 4 * imgData.width] || tmpPx[i];
           rightrightkernel = tmpPx[i + 4 * 2 * imgData.width] || tmpPx[i];
           px[i] = filterAlpha(leftleftkernel, leftkernel, middlekernel, rightkernel, rightrightkernel, px[i]);
        }
    }

    image.getContext('2d').putImageData(imgData, 0, 0);

    ctx = tmpCanvas.getContext('2d');

    ctx.globalCompositeOperation = 'source-over'; // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation

    ctx.drawImage(background, 0, 0);
    ctx.drawImage(image, 0, 0);

    cb(ctx.getImageData(0, 0, imgData.width, imgData.height));
  });
}(FakeCation));
